import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removeText',
    standalone: false
})
export class RemoveTextPipe implements PipeTransform {
  transform(text: any, args: any): unknown {
    if(args == ',,'){
      let updatedText = text?.split(args)?.join(",");
        return updatedText;
    }
    if (text?.length > 0){
        let updatedText = text?.split(args)?.join("");
        return updatedText;
    }
  }
}
